import React from "react";

const SecuritySection: React.FC = () => {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="/securitybackground.png"
          alt="Security Background"
          className="w-full h-full object-cover object-right lg:object-center"
        />
        <div className="absolute inset-0 bg-black/30 lg:bg-transparent"></div>
      </div>

      <div className="relative z-10 min-h-screen flex items-start lg:items-start pt-16 lg:pt-6">
        <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-start">
            <div className="hidden lg:block"></div>

            <div
              className="bg-black/70 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 sm:p-6 lg:p-8 shadow-xl lg:shadow-2xl w-full mx-auto lg:max-w-xl lg:ml-auto 
              max-w-sm sm:max-w-md md:max-w-lg"
            >
              <h2 className="text-white text-xl sm:text-2xl lg:text-3xl font-bold mb-4 sm:mb-6 leading-tight">
                Secure Power Solution
              </h2>

              <div className="overflow-y-auto max-h-[50vh] sm:max-h-none pr-2 -mr-2 sm:mr-0 sm:pr-0">
                <p className="text-white text-sm sm:text-base lg:text-md leading-relaxed">
                  Spectrum is an intelligent energy storage system built for
                  reliability.
                  <br/> It stores power, monitors the grid in real time,
                  and seamlessly takes over when outages occur, keeping your
                  home or facility running without interruption. Unlike
                  traditional generators, Spectrum operates silently, requires
                  no fuel or manual intervention, and delivers instant, clean
                  power when you need it most. When paired with renewable
                  sources like solar, Spectrum continuously recharges, ensuring
                  extended backup and energy independence.
                </p>
              </div>

              <div className="hidden sm:grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-6 sm:mt-8">
                <div className="flex items-center space-x-3 p-3 sm:p-3 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-green-400 rounded-full flex-shrink-0"></div>
                  <span className="text-green-400 text-xs sm:text-sm font-medium">
                    No Maintenance
                  </span>
                </div>
                <div className="flex items-center space-x-3 p-3 sm:p-3 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-green-400 rounded-full flex-shrink-0"></div>
                  <span className="text-green-400 text-xs sm:text-sm font-medium">
                    Fuel Free
                  </span>
                </div>
                <div className="flex items-center space-x-3 p-3 sm:p-3 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-green-400 rounded-full flex-shrink-0"></div>
                  <span className="text-green-400 text-xs sm:text-sm font-medium">
                    Silent Operation
                  </span>
                </div>
                <div className="flex items-center space-x-3 p-3 sm:p-3 rounded-lg bg-white/5 hover:bg-white/10 transition-colors">
                  <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-green-400 rounded-full flex-shrink-0"></div>
                  <span className="text-green-400 text-xs sm:text-sm font-medium">
                    Solar Ready
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuritySection;
